export default __webpack_public_path__ + "static/media/crossApiaryMobile.46084722.jpg";